import { enumLanguage } from "@/constants";

// 获取当前系统语言
export const getSystemLanguage = function () {
    const data = localStorage.getItem("userMsg") || "{}";
    const userMsg = JSON.parse(data);
    return userMsg.systemLanguage || enumLanguage["中文简体"];
};

// 防抖
export const debounce = function (func, delay, immediate = false) {
    let timer;
    let isInvoke = false;
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }

        if (immediate && !isInvoke) {
            func.apply(this, args);
            isInvoke = true;
        } else {
            timer = setTimeout(() => {
                func.apply(this, args);
                isInvoke = false;
            }, delay);
        }
    };
};

// 获取清理后的URL（保留路径查询参数，去除hash中的查询参数）
export const getCleanUrl = function () {
    const { origin, pathname, search, hash } = window.location;
    
    // 保留路径和路径查询参数
    let url = origin + pathname + search;
    
    // 如果有hash，只保留hash路径部分，去掉hash中的查询参数
    if (hash) {
        const hashPath = hash.split('?')[0];
        url += hashPath;
    }
    
    return url;
};
